import React, { useMemo } from 'react'
import { stringifyQuery, useQueryParams } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import HeaderNavigation from '../../../../../shared/components/headerNavigation/HeaderNavigation'
import { getTitleFromGroup } from '../../../../views/imageBrowse/helpers'
import { useDetermineMode, useGroupData, useImageOrganizeModes } from '../../../../views/imageBrowse/hooks'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'
import { useBrowseProviderContext } from '../../../../views/imageBrowse/providers/BrowseProvider'

const NavigationTopBar = () => {
  const { group, itemNumber, itemCount } = useGroupData()
  const { viewAnotherItemOverlay } = useOverlayContext()
  const { query } = useQueryParams()
  const [t] = useTranslation()
  const isOrganizeView = query.view === 'organize'
  const { isDivideMode, isMetadataAllMode, isMetadataSingleMode } = useImageOrganizeModes({})
  const { showMetadataAudit, showImageQualityAudit } = useDetermineMode()
  const { showItemBreadcrumbs } = useBrowseProviderContext()

  const showNavButtons = useMemo(() => {
    // Show buttons only when not in special modes or views
    return !(
      isOrganizeView ||
      isDivideMode ||
      isMetadataAllMode ||
      isMetadataSingleMode ||
      showMetadataAudit ||
      showImageQualityAudit
    )
  }, [isOrganizeView, isDivideMode, isMetadataAllMode, isMetadataSingleMode, showMetadataAudit, showImageQualityAudit])

  const title = useMemo(() => getTitleFromGroup(group), [group])

  const breadcrumbs = useMemo(() => {
    if (!group.metadata) return []

    const currentItemTitle =
      itemCount > 1 ? { text: t('ImageViewerHeader.itemNumber', 'Item {itemNumber}', { itemNumber }) } : null

    return [
      {
        text: `#${group.metadata?.imageGroupNumber}`,
        to: `${window.location.pathname}?${stringifyQuery(query)}`,
        onClick: viewAnotherItemOverlay.open,
      },
      currentItemTitle,
    ].filter(Boolean)
  }, [group.metadata, query, viewAnotherItemOverlay.open, itemNumber, itemCount, t])

  return (
    <HeaderNavigation
      showNavButtons={showNavButtons}
      breadcrumbs={breadcrumbs}
      title={title}
      showBreadcrumbs={showItemBreadcrumbs}
    />
  )
}

export default NavigationTopBar
